import React, { Component } from "react";
import { withCookies, Cookies } from 'react-cookie';
import { instanceOf } from 'prop-types';
import { set, get } from 'lodash';

// Services
import empresasService from '@services/empresas';
import psaService from '@services/psa';
import stationsService from '@services/stations';
import veederRootService from '@services/veederRoot';
import productsService from '@services/products';
import postosService from '@services/postos'; 

// Components
import Menu from '@components/Menu'

/* Import Components */
import Input from "@components/Input";
import Button from "@components/Button";
import AutoComplete from "@components/AutoComplete";

const newLineNozzles = () => ({ product: '' });

const newLine = () => ({
    name: "",
    host: "",
    port: "",
    client: {
        port: "",
    },
    nozzles: [newLineNozzles()]
});

class Form extends Component {
    static propTypes = {
        cookies: instanceOf(Cookies).isRequired
    };

  constructor(props) {
    super(props);

    const { match: { params } } = props;

    this.state = {
        loaded: false,
        products: [],
        empresas: [],
        warehouses: [],
        tanks: [],
        idempresa: '',
        servers: [newLine()],
        idposto: '',
        idpsa: params.idpsa,
        macaddress: '',
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
    this.handleFormCancel = this.handleFormCancel.bind(this);
    this.loadFunction = this.loadFunction.bind(this);
    this.removeFunction = this.removeFunction.bind(this);
    this.addFunction = this.addFunction.bind(this);
  }

  async loadFunction() {
    if (!this.state.loaded) {
        try {
            const empresas = await empresasService.get(true);
            const enrichedEmpresas = empresas.map((empresa) => ({ ...empresa, value: empresa.idempresa, label: empresa.nomeempresa })).filter((empresa) => empresa.combustivel);

            this.setState({ empresas: enrichedEmpresas });

            const raspberry = await psaService.getById(this.state.idpsa);

            let currentEmpresa = '';
            if (raspberry.idempresa) {
                currentEmpresa = enrichedEmpresas.find((empresa) => raspberry.idempresa === empresa.idempresa);
                this.handleChange({ target: { value: currentEmpresa, name: 'idempresa' } });
            }

            this.setState({ ...raspberry, idempresa: currentEmpresa, loaded: true });
        } catch (error) {
            console.error(error);
        }
    }
  }

  async getPostoInfo (idempresa, idposto) {
    try {
        const [station, tanks] = await Promise.all([
            stationsService.getServers(idempresa, idposto),
            veederRootService.get(idempresa, idposto)
        ]);

        const hydratedServers = station.servers ? station.servers.map((server) => ({
                ...server,
                nozzles: server.nozzles.map((nozzle) => ({
                    ...nozzle,
                    product: this.state.products.find((product) => product.idproduct === nozzle.idproduct)
                })),
        })) : [];

        const hydratedTanks = Array.isArray(tanks) ? tanks.map((tank) => ({
                ...tank,
                produto: tank.product,
                product: (this.state.products || []).find((product) => product.idproduct === tank.idproduct),
        })) : [];

        this.setState({ 
            servers: hydratedServers.length ? hydratedServers : [newLine()], 
            tanks: hydratedTanks, 
            loaded: true 
        });
    } catch (error) {
        console.error(error);
    }
  }

  async getPostosProdutos (idempresa, callBack) {
    try {
        const [products, warehouses] = await Promise.all([
            productsService.getWithFilter(idempresa, { combustivel: true }),
            postosService.get(idempresa)
        ]);

        this.setState({ products: products.map((product) => ({ ...product, value: product.idproduct, label: product.nome })) });

        const hydratedWarehouses = warehouses.map((warehouse) => ({ ...warehouse, value: warehouse.posto, label: warehouse.nome !== '' ? warehouse.nome : warehouse.posto }));

        this.setState({ warehouses: hydratedWarehouses });

        let currentPosto = '';
        if (this.state.idposto) {
            currentPosto = hydratedWarehouses.find((warehouse) => this.state.idposto === warehouse.posto);
            this.handleChange({ target: { value: currentPosto, name: 'idposto' } });
        }

        this.setState({ idposto: currentPosto, loaded: true });
        if (callBack) {
            callBack();
        }
    } catch (error) {
        console.error(error);
    }
  }

  handleChange(e, callback) {
    let value = e.target.value;
    let name = e.target.name;
    
    let newState = this.state;

    if (name.includes("|")) {
        const properties = name.split("|");

        set(newState, properties, value);

        this.setState({
            ...newState,
        });
    } else {
        this.setState({
            [name]: value,
        });
        if (name === 'idempresa') {
            return this.getPostosProdutos(value.value, callback);
        }
        if (name === 'idposto') {
            return this.getPostoInfo(newState.idempresa.value, value.value);
        }
    }

    
    if (callback) {
        callback();
    }
  }

  handleFormCancel() {
    const { history } = this.props;
    history.push('/psa');
  }

  handleFormSubmit(e) {
    const { history } = this.props;
    const { servers, tanks, idempresa, idposto, idpsa, macaddress } = this.state;
    e.preventDefault();
    
    psaService.set({
        idempresa,
        idposto,
        idpsa,
        macaddress,
        servers,
        tanks,
    })
    .then(response => {
        history.push('/psa');
    })
    .catch(error => {
        console.error(error);
    });
  }

  removeFunction(property, key) {
    const properties = property.split("|");
    let newState = this.state;

    set(newState, properties, get(newState, properties, []).filter((arrayItem, index) => index !== key));

    this.setState(newState);
  }

  addFunction(property) {
    const properties = property.split("|");
    let newState = this.state;

    let newLineValue = newLine();
    if (property.endsWith('.nozzles')) {
        newLineValue = newLineNozzles();
    }

    set(newState, properties, [ ...get(newState, properties, []), ...[newLineValue]]);

    this.setState(newState);
  }

  render() {
    const { location, history } = this.props;
    const {
        loaded,
        idempresa,
        empresas,
        products,
        warehouses,
        idposto,
        macaddress,
        idpsa,
        tanks,
    } = this.state;
    const cookies = new URLSearchParams(location.search);

    return (
        <div>
            <Menu loadFunction={ this.loadFunction } location={ location } history={ history } newCookies={ cookies } />
            <div className="fullContainer" style={{ maxWidth: '100%' }}>
                <div className="col-xs-12">
                    <ol
                        style={{
                            textAlign: 'left',
                            'marginTop': '75px',
                        }}
                        className="breadcrumb"
                    >
                        <li><a href="http://eposgestofinal.com/index.php">Portal</a></li>
                        <li><a href="/psa">Raspberry</a></li>
                        <li><a href={`/psa/${idpsa}`}>{ macaddress }</a></li>
                        <li className="active">
                            <span>Configuração</span>
                        </li>
                    </ol>
                </div>
            </div>
            {loaded && (
            <div
                className="fullContainer"
                style={{ marginTop:'25px' }}
            >
                <div
                    className="col-sm-12"
                    style={{ textAlign: 'center', fontSize: '10px' }}
                >
                    <div className="panel panel-default">
                        <div
                            className="panel-heading"
                            style={{
                                fontWeight: 'bold',
                                fontSize: '15pt',
                            }}
                        >
                           Raspberry
                        </div>
                        <form
                            style={{
                                textAlign: 'left',
                            }}
                            className="container-fluid"
                            onSubmit={this.handleFormSubmit}
                        >
                            <table className="table table-bordered table-hover table-sortable">
                                <thead>
                                    <tr >
                                        <th className="text-center">Mac</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr >
                                        <td>
                                            <Input
                                                inputType={"text"}
                                                name={`macaddress`}
                                                value={macaddress}
                                                handleChange={this.handleChange}
                                            />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <h3>Posto</h3>
                            <table className="table table-bordered table-hover table-sortable">
                                <thead>
                                    <tr >
                                        <th className="text-center">Empresa</th>
                                        <th className="text-center">Posto</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr >
                                        <td>
                                            <AutoComplete
                                                name={"idempresa"}
                                                value={idempresa}
                                                handleChange={this.handleChange}
                                                options={empresas}
                                            />
                                        </td>
                                        <td>
                                            <AutoComplete
                                                name={"idposto"}
                                                value={idposto}
                                                handleChange={this.handleChange}
                                                options={warehouses}
                                            />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            {tanks.length ? (
                                <>
                                    <h3>Tanques</h3>
                                    <table className="table table-bordered table-hover table-sortable" id="tab_logic">
                                        <thead>
                                            <tr >
                                                <th className="text-center">Veeder-Root</th>
                                                <th className="text-center">Produto</th>
                                                <th className="text-center">Litros não pescáveis</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {tanks.map((tank, key) => (
                                                <tr>
                                                    <td style={{ width: '100px' }}>
                                                        {tank.produto}
                                                    </td>
                                                    <td style={{ width: '100px' }}>
                                                        <AutoComplete
                                                            name={`tanks|${key}|product`}
                                                            value={tank.product}
                                                            handleChange={this.handleChange}
                                                            options={products}
                                                        />
                                                    </td>
                                                    <td style={{ width: '100px' }}>
                                                        <Input
                                                            inputType={"number"}
                                                            name={`tanks|${key}|loss`}
                                                            value={tank.loss}
                                                            handleChange={this.handleChange}
                                                        />
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </>
                            ) : null}
                            {/* <h3>Bombas</h3>
                                {servers.map((server, key) => (
                                    <table className="table table-bordered table-hover table-sortable" id="tab_logic">
                                        <thead>
                                            <tr >
                                                <th className="text-center">Nome</th>
                                                <th className="text-center">IP</th>
                                                <th className="text-center">Porta</th>
                                                <th className="text-center">Porta Apollo</th>
                                                <th className="text-center">&nbsp;</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td style={{ width: '100px' }}>
                                                    <Input
                                                        inputType={"text"}
                                                        name={`servers|${key}|name`}
                                                        value={server.name}
                                                        handleChange={this.handleChange}
                                                    />
                                                </td>
                                                <td style={{ width: '100px' }}>
                                                    <Input
                                                        inputType={"text"}
                                                        name={`servers|${key}|host`}
                                                        value={server.host}
                                                        handleChange={this.handleChange}
                                                    />
                                                </td>
                                                <td style={{ width: '100px' }}>
                                                    <Input
                                                        inputType={"number"}
                                                        name={`servers|${key}|port`}
                                                        value={server.port}
                                                        handleChange={this.handleChange}
                                                    />
                                                </td>
                                                <td style={{ width: '100px' }}>
                                                    <Input
                                                        inputType={"number"}
                                                        name={`servers|${key}|client|port`}
                                                        value={server.client.port}
                                                        handleChange={this.handleChange}
                                                    />
                                                </td>
                                                <td rowspan="2" style={{ width: '20px' }}>
                                                    <MdClear style={{ color: 'red', fontSize: '15px', cursor: 'pointer' }} onClick={ () => this.removeFunction('servers', key) } />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td colspan="4">
                                                    <h3>Mangueiras</h3>
                                                    <table className="table table-bordered table-hover table-sortable" id="tab_logic">
                                                        <thead>
                                                            <tr >
                                                                <th className="text-center">Número</th>
                                                                <th className="text-center">Produto</th>
                                                                <th className="text-center">&nbsp;</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {(server.nozzles || []).map((nozzle, key2) => (
                                                                <>
                                                                    <tr>
                                                                        <td style={{ width: '100px' }}>
                                                                            { key2 + 1 }
                                                                        </td>
                                                                        <td style={{ width: '100px' }}>
                                                                            <AutoComplete
                                                                                name={`servers|${key}|nozzles|${key2}|product`}
                                                                                value={nozzle.product}
                                                                                handleChange={this.handleChange}
                                                                                options={products}
                                                                            />
                                                                        </td>
                                                                        <td style={{ width: '20px' }}>
                                                                            <MdClear style={{ color: 'red', fontSize: '15px', cursor: 'pointer' }} onClick={ () => this.removeFunction(`servers|${key}|nozzles`, key2) } />
                                                                        </td>
                                                                    </tr>
                                                                </>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                    <div className="row" style={{ textAlign: 'right' }}>
                                                        <Button
                                                            action={ () => this.addFunction(`servers|${key}|nozzles`) }
                                                            type={"info"}
                                                            title={"Adicionar Mangueira"}
                                                            style={buttonStyle}
                                                        />
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                ))}
                            <div className="row" style={{ textAlign: 'right' }}>
                                <Button
                                    action={ () => this.addFunction('servers') }
                                    type={"info"}
                                    title={"Adicionar Bomba"}
                                    style={buttonStyle}
                                />
                            </div> */}
                            <Button
                                action={this.handleFormSubmit}
                                type={"success"}
                                title={"Submeter"}
                                style={buttonStyle}
                                />
                            <Button
                            action={this.handleFormCancel}
                            type={"secondary"}
                            title={"cancelar"}
                            style={buttonStyle}
                            />
                            {/* Clear the form */}
                        </form>
                    </div>
                </div>
            </div>
            )}
        </div>
    );
  }
}

const buttonStyle = {
  margin: "10px 10px 10px 10px"
};

export default withCookies(Form);
